import React, { Component } from 'react';
import "./edit.css"
import   SideNav from "../sidenav/sidenav.js"
import  AuthService  from "../api/authentication.js";
import  Moble from "../sidenav/moble.js"
import moment from 'moment';
import { DatetimePicker, DatetimePickerTrigger, DatetimeRangePicker  } from 'rc-datetime-picker';
import Moment from 'react-moment'
import 'rc-datetime-picker/dist/picker.css';
// import "rc-datetime-picker/dist/rc-datetime-picker.js"
// import "rc-datetime-picker/dist/rc-datetime-picker.js"
import axios from 'axios' 
import {
  Redirect
} from 'react-router-dom'
import Ticket from '../build/ticket';
  var Auth =  new AuthService();
  //   https://uvune-events.herokuapp.com
class Eventedit extends Component {

  constructor(props){
    super(props)
    this.state = {
        loading : false,
        noerorrpage :  true,
        domain: 'https://uvune-events.herokuapp.com',
        file: '',
        imagePreviewUrl: '', 
        paymentdata : [],
        imageurl:false,
        moment: moment(),
        description : ""
    }

  }



  
  componentDidMount(){
    this.props.noerorrpage(this.state.noerorrpage)
    const { match: { params } } = this.props;
    // console.log("params.userId",params.id, "params all", params)
           
    const requestOptions = {
        method: 'GET', 
        headers: { 'Content-Type':'application/json','Access-Control-Allow-Origin': '*'  },
    };

    fetch(this.state.domain+"/payment-item/"+params.id, requestOptions)
    .then(res => res.json())
    .then((result)=>{
        // console.log('handle uploading-', result);
        this.setState({
            paymentdata : result,
            description : result.description,
        })
      })

  }




  _handleImageChange(e) {
    e.preventDefault();

    let reader = new FileReader();
    let file = e.target.files[0];
    

    reader.onloadend = () => {
      this.setState({
        file: file,
        imagePreviewUrl: reader.result
      });
    }

    reader.readAsDataURL(file)
  }

  showTicket=(event)=>{
    event.preventDefault()
    this.setState({
      ticket : true
    })

  }

  
upDate=(e)=> {
    e.preventDefault();
    
      const datapayment ={
        name : this.name.value,
        description : this.description.value,
        amount : this.amount.value,
        venue: this.valueTK.value,
        owner: this.props.user._id,
        organizers_id : this.props.organizer._id, 
        date:this.state.moment._d
    }
    // console.log("data------>", datapayment )

  const requestOptions = {
    method: 'PATCH',
    headers: { 'Content-Type':'application/json','Access-Control-Allow-Origin': '*' ,'Authorization': Auth.getToken()  },
    body: JSON.stringify(datapayment),
  };
  fetch(this.state.domain+"/payment-item/"+ this.state.paymentdata._id, requestOptions)
        .then(res => res.json())
        .then((result)=>{
            if(result){
                // console.log("result", result)
             if(this.state.imagePreviewUrl  === ""){
                this.props.history.replace({
                    pathname: '/events/'+ this.state.paymentdata._id,
                    // state: { detail: res}
                    state: { notice: "true" , message:"Event Updated" }
                  })
             } else{
                this.data(result)
                // console.log("date", result.createdAt)
                this.setState({

                    loading:false,
                    noticeshow:true,
                    noticeMassage : "Created"
                })
             }  
              
              
            }
          
        }).catch( (error) => {
            //  console.log("errro", error);
            //  console.log("error load", error )
        });

        this.setState({
            loading:false ,
            noticeMassage : "Failed to create"
        })  
        this.timeout() 
  }

  data=(data)=>{
    // console.log("jdtbgkhjsdtg------>image",this.state.image)
    // console.log("data ----===>", data._id)
  const formData = new FormData();
    formData.append('uri', this.state.file)
    // console.log("file upload.....",this.state.file)
    formData.append('featured_image', true);
    formData.append('payment_item_id',  data._id);

    const options = {
        method: 'POST',
        headers: { 
            'content-type': 'multipart/form-data',
        'access-control-allow-origin': '*',
        'Authorization': Auth.getToken(), 
        },
        url:this.state.domain+"/upload-logo",
    };
        // console.log("data ----====>",options )
        axios.post(options.url, formData, options.headers)
          .then(res => {
            if(res){
              // console.log("data----->image", res)
              if(res.status === 201)
              // console.log("data----->image3", res)
              // this.props.history.replace(`/info/&{dgm}`);
              this.props.history.replace({
                pathname: '/events/'+ this.state.paymentdata._id,
                // state: { detail: res}
                state: { notice: "true" , message:"Event Updated" }
              })
                this.setState({
                    termsError : true,
                    termsMS : "Upload successful",
                    loadingTerms:false,
                    Ifterms :false
                })
           
         }
           
           this.timeout()
          }).catch( (error) => {
            //    console.log("error==------>",error)
               this.setState({
                 termsError : true,
                 termsMS : "Image to large",
                 loadingTerms:false,
                 Ifterms :false
               })
               this.timeout()
         });

  }

  timeout() {
    setTimeout(function() {
        this.setState({
            noticeshow : false
        })
    //   console.log(this.state.noticeshow);
    }.bind(this), 4000);
 }


  handleChange = (moment) => {
    this.setState({
      moment
    });
    // console.log("data--===>time", this.state.moment._d)
  }


  closeTicket=(event)=>{
    event.preventDefault()
    this.setState({
      ticket : false
    })

  }

  changeAbout=(e)=> {
    this.setState({ description: e.target.value });
    // console.log(this.chechconditionIinput())
}



logout = () =>{
   
  this.props.logout()
}
 
  render() {
    
      let {imagePreviewUrl} = this.state;
      let $imagePreview = null;
      if (imagePreviewUrl) {
        $imagePreview = (<img src={imagePreviewUrl} />);
      } else {
        $imagePreview = (<div className="previewText">Please select an Image for Preview</div>);
      }
      const shortcuts = {
        'Today': moment(),
        'Yesterday': moment().subtract(1, 'days'),
        'Clear': ''
      };
  
    return (
      
      this.state.submitIftrue ? (
                                
        <Redirect to={{    pathname: `${'/info'}`  }}/>

        ):
          !this.props.isAuthenticated ? (
              <div className="hero is-bold is-fullheight">
              <div className="level-item">
              <a className="button is-loading is-large is-light">Loading</a>
              </div>
              <div className="level-item">
              <span>Trying to login...</span>
              </div>
          </div>
            )
              :
              <div className="event-body-page-body-full">
                    <div className="Activity-moble-nav-body">
                        < Moble  logout={this.logout}/>
                    </div>     
                        <SideNav vanImage={this.props.organizer.image_url}  email={this.props.user.email} 
                        logout={this.logout} name={this.props.user.first_name + " " + this.props.user.last_name} 
                        organizers404={this.props.organizers404}
                        /> 

                    <div className="main"> 
                        <div className="topright">
                            {
                                this.state.noticeshow ?
                                <div className="notice-cos-tuition">
                                    {this.state.noticeMassage}
                                </div> :
                                <span> </span> 
                            }
                          </div>
                           <div className="event-edit-page-body">
                            <div className="event-edit-page-title"><p>Edit {this.state.paymentdata.name}</p></div>
                                    <div className="event-edit-page-form">
                                      {/* <b> <i className="fas fa-ticket-alt" aria-hidden="true"></i> Ticket  </b>    */}
                                  <form onSubmit={this.upDate}>
                                    <div className="field  field-input-event-style">
                                       <label className="label">Name</label>
                                       <div className="control">
                                         <input className="input" type="text" ref={input => this.name = input} defaultValue={this.state.paymentdata.name}  placeholder=" Name" required/>
                                       </div>
                                     </div>
                                     <div className="field  field-input-event-style">
                                       <label className="label">Amount</label>
                                       <div className="control">
                                         <input className="input" type="number" ref={input => this.amount = input}  defaultValue={this.state.paymentdata.amount}  placeholder=" Amount" required/>
                                       </div>
                                     </div>
                                     <div className="field field-input-event-style">
                                       <label className="label">Event Description</label>
                                       <div className="control">
                                         <textarea className="textarea"
                                         value={this.state.description} onChange={this.changeAbout} ref={ input => this.description = input}  placeholder="Description" required></textarea>
                                       </div>
                                     </div>
                                     <div className="field  field-input-event-style">
                                       <label className="label">Event Location</label>
                                       <div className="control">
                                         <input className="input"  ref={input => this.valueTK = input}  defaultValue={this.state.paymentdata.venue}type="text" placeholder="Location" required/>
                                       </div>
                                     </div>
                                     <div className="field  field-input-event-style">
                                       <label className="label">Starts At : Before <Moment  format="2015-06-17 14:24:36" date={this.state.paymentdata.date} /> </label>
                                       <div className="control">
                                        <DatetimePickerTrigger
                                            shortcuts={shortcuts} 
                                            moment={this.state.moment}
                                            onChange={this.handleChange}>
                                            <input type="text" className="input" value={this.state.moment.format('YYYY-MM-DD HH:mm')} readOnly  required/>
                                          </DatetimePickerTrigger>
                                       </div>
                                     </div>
                                   
                                     <div className="previewComponent">
                                          <div className="imgPreview">
                                                {
                                                    this.state.imagePreviewUrl  === "" ?
                                                    <img src={this.state.paymentdata.featured_image_url} />
                                                    :
                                                    $imagePreview
                                                }
                                                    
                                           </div>
                                         
                                           
 
                                               <div className="field" style={{"position":"relative","left":"15px"}}>
                                                 <div className="file is-small">
                                                   <label className="file-label">
                                                     <input className="file-input"  type="file"  onChange={(e)=>this._handleImageChange(e)} name="resume" />
                                                     <span className="file-cta">
                                                       <span className="file-icon">
                                                         <i className="fas fa-upload"></i>
                                                       </span>
                                                        <span className="file-label">
                                                            Image file…
                                                        </span>
                                                     </span>
                                                   </label>
                                                 </div>
                                               </div>
                                          </div>
                                     <hr/>
                                     <div className="field is-grouped ">
                                    
                                        <div className="control eventedit-button">
                                        <a href={'/events/'+this.state.paymentdata._id} className="button is-text">Cancel</a>  
                                        <button className="button is-link"  >Save</button>
                                        </div>
                                      
                                     </div>
                                     </form>
                                     <br/>
                                  
                              </div>
                             
                          </div>
                      </div>
              </div>
          )

}





}

export default  Eventedit ;


// WEBPACK FOOTER //
// ./src/component/create/eventedit.js